import { getLocalValue } from '@/helpers/localStorageHelper';

const routes = {
    extended: 'event-info-categories',
    express: 'event-express-edit',
};
let name = routes.extended;
export const eventsOpenMode = getLocalValue('events-open-mode', {});

export function getRouteParams(event) {
    const id = event?.id;
    if (Object.hasOwn(eventsOpenMode, id)) {
        name = routes[eventsOpenMode[id]];
    }

    return { name, id };
}
